import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  TestResponse,
  initialTestState,
  TestRequestPayload,
  DownloadTestResponse,
  DownloadOptions,
} from "../../types/interface/ProjectTrain.interface";
import AxiosInstance from "../../Service/AxiosInstance";
import { v4 as uuidv4 } from "uuid";
// Create an async thunk for adding a test
export const addTest = createAsyncThunk(
  "test/add",
  async (payload: TestRequestPayload, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      const uuid = uuidv4();
      //  formData.append("TrainingId", "11185c34-9d68-11ee-99cb-00e93adea086");
      formData.append("TrainingId", payload.model);
      formData.append("ImageData", payload.fileUpload);
      formData.append("InferenceId", uuid);
      formData.append("ProjectName", payload.projectTitle);

      const response = await AxiosInstance.post<TestResponse>(
        `${process.env.REACT_APP_SERVER_AI_API}/VisionStudio/RunInference`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      // If the error is a plain string, set it directly
      let errorMessage = "An unknown error occurred";
      if (error.response) {
        // Check if the response is a string
        errorMessage = error.response.data || error.message || errorMessage;
      } else {
        errorMessage = error.message || errorMessage;
      }
      return rejectWithValue(errorMessage);
    }
  }
);

// Create an async thunk for downloading the file and handling the download in the API call itself
export const downloadTest = createAsyncThunk<
  DownloadTestResponse,
  { trainingId: string; options?: DownloadOptions }
>("test/download", async ({ trainingId, options }, { rejectWithValue }) => {
  try {
    const startTime = Date.now();

    const response = await AxiosInstance.get(
      `${process.env.REACT_APP_SERVER_BASEURL}/api/Publish/Download?trainingId=${trainingId}`,
      {
        responseType: "blob",
        ...options, // Spread the options to include onDownloadProgress
      }
    );

    const blob = response.data;
    const url = window.URL.createObjectURL(new Blob([blob]));

    const a = document.createElement("a");
    a.href = url;
    console.log("urls----------", blob);
    // a.download = "model.zip";
    a.download = `${trainingId}.zip`;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    // const blob = response.data;
    // const url = window.URL.createObjectURL(new Blob([blob]));

    // // Extract the last parameter from the URL
    // const lastParameter = url.split("/").pop() || "default-filename.zip"; // Fallback to a default name if extraction fails

    // const a = document.createElement("a");
    // a.href = url;
    // a.download = lastParameter; // Use the last parameter as the file name
    // document.body.appendChild(a);
    // a.click();

    // document.body.removeChild(a);
    // window.URL.revokeObjectURL(url);

    const endTime = Date.now();
    const duration = endTime - startTime;

    return { success: true, duration };
  } catch (error: any) {
    // If the error is a plain string, set it directly
    let errorMessage = "An unknown error occurred";
    if (error.response) {
      // Check if the response is a string
      errorMessage = error.response.data || error.message || errorMessage;
    } else {
      errorMessage = error.message || errorMessage;
    }
    return rejectWithValue(errorMessage);
  }
});
// Create a slice for testData
const testSlice = createSlice({
  name: "test",
  initialState: initialTestState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addTest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addTest.fulfilled, (state, action) => {
        state.loading = false;
        state.testData = action.payload;
      })
      .addCase(addTest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(downloadTest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadTest.fulfilled, (state) => {
        state.loading = false;
        // Handle any post-download success state if necessary
      })
      .addCase(downloadTest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default testSlice.reducer;
